import { Descriptors, NodeFormState } from "./chainSerializer"
import { UserbotCatalog } from "../../interfaces"

const walkResultSpec = (
  specs: UserbotCatalog.FieldSpec[],
  prefix: string,
): string[] => {
  const res: string[] = []
  for (const s of specs) {
    const path = prefix ? `${prefix}.${s.key}` : s.key
    if (s.type === "object" && s.fields) {
      res.push(path)
      res.push(...walkResultSpec(s.fields, path))
    } else {
      res.push(path)
    }
  }
  return res
}

/**
 * Рекурсивный сбор всех доступных плейсхолдеров `{{<stepId>.result.<path>}}`
 * из дерева цепочки (SPEC §5.1).
 */
export const collectResultPaths = (
  nodes: NodeFormState[],
  descriptors: Descriptors,
  currentNodeId?: string,
): string[] => {
  const result: string[] = []

  const visitNode = (node: NodeFormState) => {
    if (node.kind === "action") {
      if (node.id && node.id !== currentNodeId) {
        const desc = descriptors[node.action]
        if (desc && desc.result && desc.result.length > 0) {
          const subPaths = walkResultSpec(desc.result, "")
          for (const sp of subPaths) {
            result.push(`{{${node.id}.result.${sp}}}`)
          }
        }
      }
    } else if (node.kind === "branch") {
      for (const c of node.cases) {
        c.then.forEach(visitNode)
      }
      node.elseSteps?.forEach(visitNode)
    } else if (node.kind === "forEach") {
      node.body.forEach(visitNode)
    } else if (node.kind === "callChain") {
      node.inlineSteps?.forEach(visitNode)
    }
  }

  nodes.forEach(visitNode)
  return result
}
